<nb-card>
  <nb-card-header>
    <!-- Title -->
    <div class="title" i18n="@@MyExercise">My Exercise</div>
    <div class="actions">
      <!-- Search -->
      <nb-form-field class="search-field">
        <input nbInput #search shape="semi-round" fieldSize="small" class="search" i18n-placeholder="@@SearchThreeDots" >
        <nb-icon nbSuffix icon="search-outline" pack="eva"></nb-icon>
      </nb-form-field>
      <!-- Add -->

    </div>
  </nb-card-header>

  <nb-card-body>
   
    <ngx-skeleton-item-list *ngIf="!contentLoaded"></ngx-skeleton-item-list>

    <mat-table [class.hidden]="!contentLoaded" [dataSource]="dataList" matSort [matSortDisableClear]="true" (matSortChange)="onSortChanged($event)">

      <!-- Image Column -->
      <ng-container matColumnDef="image">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@Image">Image</mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="Image" i18n-data-label="@@Image">
          <img *ngIf="row.exerciseImageUrl || row.exerciseVideoThumbnailUrl" [src]="row.exerciseImageUrl && row.exerciseImageUrl != 'null' ? row.exerciseImageUrl: row.exerciseVideoThumbnailUrl" loading="lazy"/>
          <video *ngIf="!row.exerciseImageUrl && !row.exerciseVideoThumbnailUrl && row.exerciseVideoUrl" style="max-height: 90px;
          max-width: 90px;">
          <source [src]="getVideoUrl(row.exerciseVideoUrl)"
          type="video/mp4">
        Your browser does not support the video tag. {{row.exerciseVideoUrl}}
      </video>
        </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@Name"> Name </mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="Name" i18n-data-label="@@Name"> {{row.name}} </mat-cell>
      </ng-container>

      <!-- Last Update Column -->
      <ng-container matColumnDef="updatedDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@LastUpdate"> Last Update </mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="Last Update" i18n-data-label="@@LastUpdate">
          {{row.updatedDate | date:'mediumDate'}}
        </mat-cell>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@Actions"> Actions </mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="Actions" i18n-data-label="@@Actions">
          <button nbButton ghost shape="round" size="small" (click)="onEdit(row.id)">
            <img src="/assets/icons/added_oultine_modify_pencil.svg" alt="edit" class="img-archive" width="24"
              height="24">
          </button>
          <button nbButton ghost shape="round" size="small" (click)="onDelete(row.id)">
            <img src="/assets/icons/trash-2-outline.svg" alt="delete" class="img-archive" width="24" height="24">
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <mat-paginator #paginator [length]="totalCount" [pageSize]="10" (page)="loadDataList(true)"
      [class.hidden]="totalCount === 0">
    </mat-paginator>

    <div *ngIf="contentLoaded && totalCount === 0" class="text-center p-4">
      <button nbButton hero *ngIf="!readonly" size="small"  class="btn-circle btn-xl btn-main" (click)="onAddCustomExercise()">
        <nb-icon icon="plus"></nb-icon> <span>Create a new Exercise</span>
      </button>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <div style="width: auto; float: right;">
      <button i18n="@@AddNew" nbButton class="btn-circle btn-xl btn-main" (click)="onAddCustomExercise()">
        Add New
      </button>
    </div>
  </nb-card-footer>
</nb-card>
